import PropTypes from 'prop-types';
import { DateInput, DropdownSelect, TextInput, Row, Col } from '@figure/frontlib-gui';
import { SUFFIX_TYPE } from 'shared/constants/profile';
import { Citizenship } from 'shared/constants';

const NameSectionForm = ({ values, errors, touched, setFieldValue, autoCompleteOn }) => (
  <>
    <Row>
      <Col md={5}>
        <TextInput
          id="first-name"
          data-test-id="name-firstName"
          label="Legal first name"
          value={values.name.firstName}
          errorText={touched.name?.firstName && errors.name?.firstName}
          onChange={(e) => setFieldValue('name.firstName', e.target.value)}
          maxLength="128"
          autoComplete={autoCompleteOn.toString()}
          required
        />
      </Col>

      <Col md={5}>
        <TextInput
          id="last-name"
          data-test-id="name-lastName"
          label="Legal last name"
          value={values.name.lastName}
          errorText={touched.name?.lastName && errors.name?.lastName}
          onChange={(e) => setFieldValue('name.lastName', e.target.value)}
          maxLength="128"
          autoComplete={autoCompleteOn.toString()}
          required
        />
      </Col>

      <Col md={2}>
        <DropdownSelect
          id="suffix"
          data-test-id="name-suffix"
          label="Suffix"
          value={values.name.suffix}
          errorText={touched.name?.suffix && errors.name?.suffix}
          onChange={(e) => setFieldValue('name.suffix', e.target.value)}
          autoComplete={autoCompleteOn.toString()}
        >
          <option value="" />
          {SUFFIX_TYPE.map((suffix) => (
            <option key={suffix.value} value={suffix.value}>
              {suffix.label}
            </option>
          ))}
        </DropdownSelect>
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <DateInput
          id="dob"
          data-test-id="name-dob"
          label="Date of birth"
          value={values.dob}
          errorText={touched?.dob && errors?.dob}
          onChange={(v) => setFieldValue('dob', v)}
          placeholder="MM/DD/YYYY"
          maxLength="12"
        />
      </Col>

      <Col md={6}>
        <DropdownSelect
          id="citizenship"
          label="Citizenship"
          name="citizenship"
          data-test-id="citizenship"
          value={values.citizenship}
          errorText={touched?.citizenship && errors?.citizenship}
          required
          onChange={(e) => setFieldValue('citizenship', e.target.value)}
        >
          <option value="" disabled />
          {Citizenship.CITIZENSHIP_TYPE.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </DropdownSelect>
      </Col>
    </Row>
  </>
);

NameSectionForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  autoCompleteOn: PropTypes.bool,
};

NameSectionForm.defaultProps = {
  autoCompleteOn: true,
};

export default NameSectionForm;
